export default "__VITE_ASSET__BiscJeCl__"